import React from "react";
import { Container, Typography, Grid } from "@mui/material";
import HomeCard from "../Component/HomeCard/HomeCard"; // Import your home design card component
import VideoCorousel from "../Component/VideoCorousel/VideoCorousel";

export default function Renovations() {
  // Custom Homes Data
  const RenovationsData = [
    {
      name: "Luxury Villa",
      bedrooms: 4,
      bathrooms: 3,
      parking: 2,
      totalArea: "3,500 sqft",
      landCovered: "2,800 sqft",
      image: "assets/Image (3).jpg",
    },
    {
      name: "Modern Mansion",
      bedrooms: 5,
      bathrooms: 4,
      parking: 3,
      totalArea: "5,000 sqft",
      landCovered: "4,200 sqft",
      image: "assets/Image (3).jpg",
    },
    {
      name: "Elegant Residence",
      bedrooms: 3,
      bathrooms: 3,
      parking: 2,
      totalArea: "2,800 sqft",
      landCovered: "2,300 sqft",
      image: "assets/Image (3).jpg",
    },
    {
      name: "Urban Retreat",
      bedrooms: 4,
      bathrooms: 4,
      parking: 2,
      totalArea: "3,200 sqft",
      landCovered: "2,500 sqft",
      image: "assets/Image (3).jpg",
    },
  ];

  return (
    <div>

        <VideoCorousel />
    <Container maxWidth="xl" style={{ padding: "40px" }}>

      <Typography variant="h3" align="center" gutterBottom>
      Renovations Designs
      </Typography>
      <Grid container spacing={4}>
        {RenovationsData.map((home, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <HomeCard home={home} />
          </Grid>
        ))}
      </Grid>
    </Container>
    </div>
  );
}
